export default __webpack_public_path__ + "static/media/grabpay.c6a433b1.svg";